<template>
  <div class="home">
    <Filters
      :service-places="servicePlaces"
      :nationalities="nationalities"
      :active.sync="filterShow"
      @filter-submit="handleFilterSubmit"
    />
    <div class="page-container">
      <p class="bar">
        <img :src="positionIcon" class="position" alt="" />
        <span class="city">{{ city }}</span>
        <router-link :to="{ name: 'goddessSearch' }">
          <img :src="searchIcon" class="search" alt="" />
        </router-link>
      </p>
      <Banner />
      <Group />
      <div class="tab-container">
        <ml-loading v-if="tabLoading" />
        <template v-else>
          <Tabs
            :tool-icon="filterIcon"
            :active.sync="active"
            :tab-list="servicePlaces"
            class="tabs"
            @tool-click="filterShow = $event"
            @change-tab="handleChangeTab"
          />
          <ml-loading v-if="goddessesLoading" />
          <GridLayoutGoddess v-else :goddesses="goddesses" />
          <ml-loading class="loading-bottom" v-if="goddessesBottomLoading" />
          <div v-if="isOver" class="over">
            已经到底了
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import positionIcon from "@/assets/icons/home/position@2x.png";
import searchIcon from "@/assets/icons/home/search@2x.png";
import filterIcon from "@/assets/icons/tabbar/filter_home@2x.png";
import avatar_1 from "@/assets/icons/home/avatar_1@2x.png";
import GridLayoutGoddess from "@/views/home/components/GridLayoutGoddess";
import Banner from "@/components/Banner";
import Tabs from "@/components/Tabs.vue";

import { getGoddess, getGoddessFilter } from "@/api/goddness";
import { getGroups } from "@/api/group";
import { getNationalities, getServicePlaces } from "@/api/platform";
import { getCurrentCity } from "@/api/position";
import Group from "@/views/home/components/Group";
import Filters from "./components/Filters";
import { mapActions, mapGetters } from "vuex";
import { getInviteCode } from "@/utils/inviteCode";

export default {
  name: "Home",
  components: {
    GridLayoutGoddess,
    Group,
    Banner,
    Tabs,
    Filters
  },
  data: function() {
    return {
      active: 0,
      avatar_1,
      // 静态资源
      positionIcon,
      searchIcon,
      filterIcon,
      // Filters
      filterShow: false,
      goddesses: [],
      goddessesLoading: false,
      goddessesBottomLoading: false,
      goddessesOver: false,
      nationalities: [],
      // Tab
      servicePlaces: [],
      tabLoading: false,
      group: "",
      city: "",
      currentTab: "",
      pagination: {
        page: 0,
        total: 0
      },
      isFilter: false
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters("user", ["logged"]),
    isOver() {
      if (this.pagination.total === 0) {
        return false;
      }
      return this.pagination.page >= this.pagination.total;
    }
  },
  methods: {
    ...mapActions("user", ["getInfo"]),
    async fetchData() {
      this.goddessesLoading = true;
      this.tabLoading = true;
      this.isFilter = false;
      const getGoddessPending = getGoddess(this.currentTab, this.pagination);
      const servicePlaces = getServicePlaces();
      const groupPending = getGroups();
      const positionPending = getCurrentCity();
      //TODO: 为什么  await getHomeBannerPending.content 结果不一样
      const city = await positionPending;
      this.city = city.length > 0 ? city : "海外";
      const responseServicePlacesData = await servicePlaces;
      responseServicePlacesData.unshift("全部");
      this.servicePlaces = responseServicePlacesData;
      this.tabLoading = false;
      const responseGoddessData = await getGoddessPending;
      this.goddesses = responseGoddessData.content;
      this.pagination.page = responseGoddessData.pageable.pageNumber;
      this.pagination.total = responseGoddessData.totalPages;
      this.goddessesLoading = false;
      const group = await groupPending;
      this.group = group[0];
      // 筛选器的数据后请求
      this.nationalities = await getNationalities();
    },
    async handleFilterSubmit(filter) {
      this.goddessesLoading = true;
      this.isFilter = true;
      const responseGoddessData = await getGoddessFilter(filter);
      this.goddesses = responseGoddessData.content;
      this.pagination.total = 0;
      this.active = 0;
      this.goddessesLoading = false;
    },
    async handleChangeTab(tab) {
      this.goddessesLoading = true;
      this.isFilter = false;
      this.currentTab = tab;
      this.pagination = {
        page: 0,
        total: 0
      };
      this.goddesses = [];
      const responseGoddessData = await getGoddess(
        this.currentTab,
        this.pagination
      );
      this.goddesses = responseGoddessData.content;
      this.pagination.page = responseGoddessData.pageable.pageNumber;
      this.pagination.total = responseGoddessData.totalPages;
      this.goddessesLoading = false;
    },
    async handleScrollBottom() {
      if (this.isOver || this.isFilter) {
        return;
      }
      this.goddessesBottomLoading = true;
      const responseGoddessData = await getGoddess(
        this.currentTab,
        this.pagination
      );
      this.goddesses = [...this.goddesses, ...responseGoddessData.content];
      this.pagination.page = responseGoddessData.pageable.pageNumber;
      this.pagination.total = responseGoddessData.totalPages;
      this.goddessesBottomLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .bar {
    margin: 0 0 20px 0;
    text-align: left;
    .position {
      margin-right: 7px;
      width: 18px;
      height: 22px;
      vertical-align: top;
    }
    .city {
      font-size: 18px;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      line-height: 25px;
      vertical-align: middle;
    }
    .search {
      float: right;
      width: 24px;
      height: 24px;
    }
  }
  .tab-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    .tabs {
      margin: 20px 0;
    }
  }
  .over {
    margin-top: 10px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
  }
}
</style>
